module.exports = __webpack_public_path__ + "img/11.50b6a618.png";